/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { TriggerArgs_ChannelCallback } from "../../trigger_args";

export const protobufPackage = "complimentary_actions";

export interface DummyChannelTriggeredActionArgs {
  trigger:
    | TriggerArgs_ChannelCallback
    | undefined;
  /** Number of times the callback should be triggered before it reports done. */
  numTriggers: number;
}

function createBaseDummyChannelTriggeredActionArgs(): DummyChannelTriggeredActionArgs {
  return { trigger: undefined, numTriggers: 0 };
}

export const DummyChannelTriggeredActionArgs = {
  encode(message: DummyChannelTriggeredActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.trigger !== undefined) {
      TriggerArgs_ChannelCallback.encode(message.trigger, writer.uint32(10).fork()).ldelim();
    }
    if (message.numTriggers !== 0) {
      writer.uint32(16).int32(message.numTriggers);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DummyChannelTriggeredActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDummyChannelTriggeredActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trigger = TriggerArgs_ChannelCallback.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.numTriggers = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DummyChannelTriggeredActionArgs {
    return {
      trigger: isSet(object.trigger) ? TriggerArgs_ChannelCallback.fromJSON(object.trigger) : undefined,
      numTriggers: isSet(object.numTriggers) ? globalThis.Number(object.numTriggers) : 0,
    };
  },

  toJSON(message: DummyChannelTriggeredActionArgs): unknown {
    const obj: any = {};
    if (message.trigger !== undefined) {
      obj.trigger = TriggerArgs_ChannelCallback.toJSON(message.trigger);
    }
    if (message.numTriggers !== 0) {
      obj.numTriggers = Math.round(message.numTriggers);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DummyChannelTriggeredActionArgs>, I>>(base?: I): DummyChannelTriggeredActionArgs {
    return DummyChannelTriggeredActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DummyChannelTriggeredActionArgs>, I>>(
    object: I,
  ): DummyChannelTriggeredActionArgs {
    const message = createBaseDummyChannelTriggeredActionArgs();
    message.trigger = (object.trigger !== undefined && object.trigger !== null)
      ? TriggerArgs_ChannelCallback.fromPartial(object.trigger)
      : undefined;
    message.numTriggers = object.numTriggers ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
